"use client";

import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";
import { getSession, type SessionResponse } from "src/server/utils/getSession";

type SessionContextType = {
  session: SessionResponse;
};

const defaultSessionContext = {
  session: { is_logged_in: false },
};

const SessionContext = createContext<SessionContextType>(defaultSessionContext);

export const useSessionContext = () => {
  return useContext(SessionContext);
};

export const SessionProvider = ({ children }: { children: ReactNode }) => {
  const [session, setSession] = useState<SessionResponse>(
    defaultSessionContext.session,
  );

  useEffect(() => {
    const fetchSession = async () => {
      const session = await getSession(document.cookie);
      setSession(session);
    };
    fetchSession();
  }, []);

  return (
    <SessionContext.Provider
      value={{
        session,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};
